import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ProCard from '@ant-design/pro-card';
import { Col, Row } from 'antd';
import { Link } from 'react-router-dom';
const shortcutsStyle = {
    background: 'rgba(84, 148, 252, 0.0500)',
    borderRadius: 8,
    padding: '15px 24px',
    display: 'flex',
    alignItems: 'center',
};
export const ShortcutMenu = ({ title, menus, }) => {
    return (_jsx(_Fragment, { children: _jsx(ProCard, { title: title, children: _jsx(Row, { gutter: [24, 24], wrap: true, children: menus.map(({ title: _title, icon: Icon, link }) => {
                    return (_jsx(Col, { xl: 8, xs: 24, children: _jsxs(Link, { to: link, style: shortcutsStyle, children: [_jsx(Icon, {}), _jsx("span", { style: { marginLeft: 16, fontSize: 16, color: '#393939' }, children: _title })] }) }, link));
                }) }) }) }));
};
